'use client';

import type { IndustrialCaseSummary } from '@/domain/industrialCase/industrialCaseSummary';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import Safety from '@/components/apps/pages/solution/safety/Safety';
import { SAFETY_SOLUTION_ID } from '@/components/apps/pages/solution/safety/safetyAnalytics';
import { useSolutionLandingAnalytics } from '@/components/apps/pages/solution/shared/useSolutionLandingAnalytics';
import VisuallyHiddenPageTitle from '@/components/apps/ui/a11y/VisuallyHiddenPageTitle';

type Props = {
  lng: string;
  /** Published Safety cases prepared by the route for this language */
  safetyCases: ReadonlyArray<IndustrialCaseSummary>;
};

export default function SafetyPageClient({ lng, safetyCases }: Props) {
  const { t } = useTranslation('common');
  const title = t('안전 솔루션');
  const pageRef = useRef<HTMLDivElement | null>(null);
  useSolutionLandingAnalytics(pageRef, {
    solutionId: SAFETY_SOLUTION_ID,
    language: lng,
  });

  return (
    <div ref={pageRef}>
      <VisuallyHiddenPageTitle>{title}</VisuallyHiddenPageTitle>
      <ResponsiveLayout mobilePadding={{ top: '0', bottom: '0' }}>
        <Safety safetyCases={safetyCases} />
      </ResponsiveLayout>
    </div>
  );
}
